export function mapInvoiceServicesToPayload(invoiceServices) {
  return invoiceServices.map((invoiceService) => ({
    icsId: invoiceService.icsId,
    amount: invoiceService.amount,
    rushFee: invoiceService.rushFee,
  }))
}
export function mapRadiologistInvoiceServicesToPayload(invoiceServices) {
  return invoiceServices.map((invoiceService) => ({
    invoiceServiceId: invoiceService.invoiceServiceId,
    amount: invoiceService.amount,
  }))
}